export const userSelector = {
  next: 'Next',
  previous: 'Previous',
};
